import React from 'react';

export const AngleDown = () => {
  return (
    <svg
      width="12"
      viewBox="0 0 12 7"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
    >
      <path
        d="M6 7c-.256 0-.512-.098-.707-.293l-5-5c-.39-.391-.39-1.023 0-1.414.391-.391 1.024-.391 1.414 0L6 4.588 10.294.294c.391-.391 1.023-.391 1.414 0 .391.39.391 1.023 0 1.414l-5 5C6.513 6.903 6.256 7 6 7z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
};
